export default "__VITE_ASSET__CBKifO67__"